import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonComponent } from '../button/button.component';
import { CardComponent } from '../card/card.component';

@Component({
  selector: 'app-profile-section-row',
  standalone: true,
  imports: [CommonModule, TranslocoPipe, ButtonComponent, CardComponent],
  templateUrl: './profile-section-row.component.html',
  styleUrls: ['./profile-section-row.component.scss'],
})
export class ProfileSectionRowComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() documentName: string = '';
  @Input() status: null = null; // Always null to hide the status badge
  @Input() showEditButton: boolean = true;
  @Input() showDeleteButton: boolean = true;
  @Input() hasAttachment: boolean = false;
  @Input() isAiParsed: boolean = false;
  @Input() showSaveButton: boolean = false;
  @Input() hasValidationErrors: boolean = false;
  @Input() validationMessage: string = '';
  @Input() isValid: boolean = true;
  // Optional, generic proficiency meter rendered under the subtitle. The
  // parent decides what `filled`/`total` mean (e.g. CEFR a1..c2 = 1..6) and
  // supplies a `variant` slug that maps to a fill colour in the stylesheet.
  @Input() levelMeter: { filled: number; total: number; variant: string } | null = null;

  @Output() edit = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();

  /** Segment indices [1..total] for the proficiency meter's *ngFor. */
  get levelMeterSegments(): number[] {
    const total = this.levelMeter?.total ?? 0;
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  onEdit(): void {
    this.edit.emit();
  }

  onDelete(): void {
    this.delete.emit();
  }

  onSave(): void {
    this.save.emit();
  }
}
